import React from 'react'

import Generic from '../../components/Generic'
import { Props, createGetStaticProps } from '../../data'

import ROUTE from './route'

import { PageConfig } from 'src/routing/types'

const CodeOfConduct: PageConfig<Props> = (props) => <Generic {...props} />

CodeOfConduct.route = ROUTE

export const getStaticProps = createGetStaticProps(ROUTE.path().slice(1))
export default CodeOfConduct
